import { connect, MapDispatchToProps, type MapStateToProps } from 'react-redux';
import { PapiDeviation } from '@wix/da-papi-types';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/actionCreators';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { Props } from './SubmitButton';
import { getScheduleTimestamp } from '../../../redux/selectors';

export type StateProps = Pick<Props, 'scheduleTimestamp'>;
export type DispatchProps = Pick<Props, 'onScheduleClick'>;
export type OwnProps = Omit<Props, keyof DispatchProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = state => ({
  scheduleTimestamp: getScheduleTimestamp(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = dispatch => ({
  onScheduleClick: (deviation: PapiDeviation) =>
    dispatch(
      pushModal(ModalType.DEVIATION_SUBMIT_SCHEDULE, {
        params: {
          deviation,
          scheduleTimestamp: deviation.scheduledPublishTime,
        },
      })
    ),
});

export default connect(mapStateToProps, mapDispatchToProps);
